import * as Backbone from "backbone-associations";
import { prop } from "../../decorators/property";

export class SearchCitationSourceModel extends Backbone.AssociatedModel {

    @prop() public Code: string;
    @prop() public Id: string;
    @prop() public IsNeutral: boolean;
    @prop() public Name: string;
    @prop() public Rank: number;

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/search-citation-source.ts